import { OperadoraService } from 'src/app/api-service/operadora.service';
import { NotificacoesHubService } from './../../core/services/notificacoes/notificacoesHub.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ShowModalService } from 'src/app/services/show-modal.service';

import { Paginacao } from 'src/app/share/Paginacao';
import { AlertifyService } from 'src/app/api-service/alertify.service';
import { versaoApp } from 'src/environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EventEmitterBaseService } from 'src/app/core/services/event-emitter-service/event-emitter.service';
import { SessionService } from '../../core/services/session/session.service';
import { CognitoService } from '../../core/services/cognito/cognito.service';
import { Router } from '@angular/router';
import { BilhetadoraService } from 'src/app/api-service/bilhetadora.service';
import { Bilhetadora } from 'src/app/models/bilhetadora';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  public versao = versaoApp;
  isCollapsed = true;
  formTrocaSenha: FormGroup;
  email: string = '';

  paginacao: Paginacao<any>;
  perPage: number = 10;

  permissaoListar: any;
  public modalRef: BsModalRef;
  public bilhetadoraNomeFantasia = '';
  public operadoraNomefantasia = '';

  constructor(
    private appService: AppService,
    public session: SessionService,
    private authService: AuthService,
    private fb: FormBuilder,
    private bilhetadoraService: BilhetadoraService,
    public showModalService: ShowModalService,
    private alertify: AlertifyService,
    public notificacoesHubService: NotificacoesHubService,
    public cognito: CognitoService,
    private operadoraService: OperadoraService,
    public router: Router
  ) {
    this.paginacao = new Paginacao('', 1, this.perPage, false);
  }

  private pad(num: number, size: number): string {
    let s = num + '';
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
  }

  ngOnInit() {
    this.createForm();
  }

  public async ngAfterViewInit() {
    if (this.session.hasBilhetadoraId()) {
      await this.getBilhetadoras();
    }
    if (this.session.hasOperadoraId()) {
      await this.getOperadora();
    }
  }

  createForm() {
    this.formTrocaSenha = this.fb.group({
      senha: ['', [Validators.required, Validators.pattern(/^(?=.*\d)[0-9a-zA-Z$*&@#]{4,}$/)]],
      contraSenha: ['', [Validators.required, Validators.pattern(/^(?=.*\d)[0-9a-zA-Z$*&@#]{4,}$/)]],
      codigo: ['', Validators.required],
    });
  }

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }

  logout() {
    this.session.logout();
  }

  modalTrocarSenha(event, template: TemplateRef<any>) {
    event.stopPropagation();
    this.authService.showLoadingEmitter.emit(true);
    this.showModalService.show(template, 'modal-md');
    this.authService.showLoadingEmitter.emit(false);
  }

  public enviaCodigoVerificacao() {
    this.authService.showLoadingEmitter.emit(true);
    this.authService
      .getTokenTrocaSenha(this.email)
      .toPromise()
      .then((res) => {
        if (!res) {
          this.alertify.error('Usuário não encontrado, verifique e tente novamente', 3);
        } else {
          this.alertify.success('O código foi enviado para o email informado', 3);
        }
        this.authService.showLoadingEmitter.emit(false);
      });
  }

  public verificaSenha(): boolean {
    return this.formTrocaSenha.get('senha').value === this.formTrocaSenha.get('contraSenha').value;
  }

  public alteraSenha() {
    this.alertify.confirm('Alterar Senha', 'Você tem certeza que deseja alterar a senha?').then((ok) => {
      if (!this.formTrocaSenha.get('senha').valid || !this.formTrocaSenha.get('contraSenha').valid) {
        this.alertify.error('Preencha todos os campos corretamente', 3);
      } else {
        this.authService.showLoadingEmitter.emit(true);
        this.authService
          .alteraSenha(this.email, this.formTrocaSenha.get('codigo').value, this.formTrocaSenha.get('senha').value)
          .toPromise()
          .then((res) => {
            if (res) {
              this.alertify.success('Senha alterada com sucesso', 3);
            } else {
              this.alertify.error('Erro ao alterar senha', 3);
            }
            this.authService.showLoadingEmitter.emit(false);
          });
        this.showModalService.hide();
        this.logout();
      }
    });
  }

  showModalNotificacoes() {
    EventEmitterBaseService.get('openNotificationsModal').emit();
  }

  public getNomeUsuario() {
    return this.session.getNomeUsuario();
  }

  private async getBilhetadoras(): Promise<void> {
    this.authService.showLoadingEmitter.emit(true);
  
    try {
      const resp = await this.bilhetadoraService.getBilhetadoraPorId(this.session.getBilhetadoraId());
  
      if (resp) {
        this.bilhetadoraNomeFantasia = resp.data.nomeFantasia
      } else {
        this.bilhetadoraNomeFantasia = '';
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.authService.showLoadingEmitter.emit(false);
    }
  }

  private async getOperadora(): Promise<void> {
    this.authService.showLoadingEmitter.emit(true);
  
    try {
      const resp = await this.operadoraService.getOperadoraPorId(this.session.getOperadoraId());
  
      if (resp) {
        this.operadoraNomefantasia = resp.data.nomeFantasia
      } else {
        this.operadoraNomefantasia = '';
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.authService.showLoadingEmitter.emit(false);
    }
  }
  
}
